import { TextInput } from '@mantine/core';
import { memo } from 'react';
import {
  shouldUseTextarea,
  calculateTextareaRows,
} from '../../utils/translations/translationHelpers';
import { RichTextarea } from './RichTextarea';

type TranslationValueInputProps = {
  value: unknown;
  onChange: (value: string) => void;
};

function normalizeToString(value: unknown): string {
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.join('\n');
  if (value === null || value === undefined) return '';
  return String(value);
}

export const TranslationValueInput = memo(function TranslationValueInput({
  value,
  onChange,
}: TranslationValueInputProps) {
  const normalizedValue = normalizeToString(value);
  const useTextarea = shouldUseTextarea(value);

  if (useTextarea) {
    return (
      <RichTextarea
        value={normalizedValue}
        onChange={onChange}
        rows={calculateTextareaRows(value)}
        minRows={3}
        maxRows={10}
      />
    );
  }

  return (
    <TextInput
      value={normalizedValue}
      onChange={e => onChange(e.currentTarget.value)}
    />
  );
});
